export const navbar = {
    // 用户下拉菜单
    "navbar_update_password": "修改密码",
    "navbar_logout": "退出登录",
    "navbar_menu": "菜单",
    // 登录按钮（未登录状态）
    "navbar_login": "登录",
    // 其他导航
    "navbar_to_Management": "管理",
    "navbar_to_FileLog": "文件日志",
    // 修改密码弹窗
    "navbar_update_password_modal_title": "修改密码",
    "navbar_change_password_button": "更改密码",
    // 密码验证与反馈消息
    "navbar_password_mismatch": "新密码与确认密码不一致。",
    "navbar_password_update_success_message": "密码已成功更新。",
    "navbar_password_update_success_notify": "密码修改成功。",
    "navbar_password_update_failed": "密码更新失败。",
    // 表单标签与提示
    "navbar_original_password": "原密码",
    "navbar_new_password": "新密码",
    "navbar_confirm_new_password": "确认新密码",
};
